import { FaLinkedin } from "react-icons/fa";
import React from "react"
import { BaseIcon } from "./BaseIcon"

interface Props {
	color?: string
	className?: string
}

export const IconLinkedin = ({color, className}: Props) => {
	return (
		<BaseIcon color={color} className={className}>
			<FaLinkedin/>
		</BaseIcon>
	)
}
